import React, { useState, useEffect } from "react";
import { Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import { useDispatch } from "react-redux";
import {
    getActivityFromSpecificTrainingAction,
    getCountdownFromActivityFromTrainingAction,
} from "@icarius-pages/myTraining/actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";

const formatRemaining = (ms) => {
    if (ms <= 0) return "00:00:00";
    const totalSeconds = Math.floor(ms / 1000);
    const h = Math.floor(totalSeconds / 3600);
    const m = Math.floor((totalSeconds % 3600) / 60);
    const s = totalSeconds % 60;
    return [h, m, s].map((v) => String(v).padStart(2, "0")).join(":");
};

const Countdown = (props) => {
    const { trainingData, activityData } = props;

    const startTime = activityData.countdown.startTime;
    const currentTime = activityData.countdown.currentTime;
    const endTime = activityData.countdown.endTime;

    const dispatch = useDispatch();

    const [now, setNow] = useState(new Date(currentTime));
    const color = useSelector(getAppColor);

    const start = new Date(startTime);
    const end = new Date(endTime);
    const remaining = end - now;
    const remainingAsPercentage = Math.min(100, Math.max(0, (remaining / (end - start)) * 100)).toFixed(2);

    useEffect(() => {
        // mover el cronometro cada un segundo
        if (remaining === 0) return;
        const interval = setInterval(() => setNow((prev) => new Date(prev.getTime() + 1000)), 1000);
        return () => clearInterval(interval);
    }, [now, remaining]);

    useEffect(() => {
        // traer el countdown actualizado por SV al volver a la pestaña del navegador (si esta fuera de foco el cronometro puede desfasarse)
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                if (!now || remaining === 0) return;

                dispatch(getCountdownFromActivityFromTrainingAction(trainingData.id, activityData.id)).then((resp) => {
                    if (resp.status === 200) {
                        setNow(new Date(resp.data.countdown.currentTime));
                    }
                });
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);
        return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, [dispatch, activityData.id, trainingData.id, now, remaining]);

    useEffect(() => {
        // cuando el cronometro llega a 0, traer los datos de la actividad de nuevo
        if (remaining === 0) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("timeIsUp"), severity: "info" }));
            dispatch(getActivityFromSpecificTrainingAction(trainingData.id, activityData.id));
            return;
        }
    }, [dispatch, trainingData.id, activityData.id, remaining]);

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
            {remaining > 0 && <Typography align="center">{getLocalizedString("timeRemaining")}:</Typography>}
            <div
                style={{
                    height: 40,
                    width: "100%",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        width: "100%",
                        position: "absolute",
                        zIndex: 3,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "100%",
                    }}
                >
                    <Typography className="whiteText" style={{ fontSize: 25 }}>
                        {remaining > 0 ? formatRemaining(remaining) : getLocalizedString("timeIsUp")}
                    </Typography>
                </div>
                {remaining > 0 && (
                    <>
                        <div
                            style={{
                                zIndex: 2,
                                height: "100%",
                                width: "100%",
                                position: "absolute",
                                borderRadius: 15,
                                overflow: "hidden",
                            }}
                        >
                            <div
                                style={{
                                    height: "100%",
                                    width: `${remainingAsPercentage}%`,
                                    backgroundColor: color,
                                }}
                            />
                        </div>
                        <div
                            style={{
                                height: "100%",
                                width: "100%",
                                position: "absolute",
                                borderRadius: 15,
                                border: `2px solid ${color}`,
                            }}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default Countdown;
